export default{
    namespaced: true,
    state:{
        stepMetas:{//组件具体数据

        } ,
        versionTip:'由于流程升级,发布前请先保存流程',
        version:'',
        setpNames:{},
        flowDatas:{//保存整个流程结构
           
        },
        cloneData:[],//复制的数据
        fatherOutput:null,//父job的输出数据
    },
    mutations:{
        setVersion(state,version){
            state.version=version;
        },
        addStepMeta(state,{active,obj}){
            const json=Object.assign({},state.stepMetas[active],obj);
            state.stepMetas=Object.assign({},state.stepMetas,{[active]:json});
        },
       
        addFlowDatas(state,{key,obj}){
            state.flowDatas[key]=obj;
        },
        removeFlowStep(){

        },
        addFlowHops(state,hops){
            state.flowDatas.hops=hops;
        },
        resetSetMeta(state,data){
            state.stepMetas=data;
        },
        resetFlowDatas(state,data){
            state.flowDatas=data;
        },
        addClone(state,data){
            state.cloneData = data;
        },
        addFatherOutput(state,data){
            console.log('data',data)
            state.fatherOutput = data;
        }

    }
};


// WEBPACK FOOTER //
// ./src/stores/modules/flow.js